import { determineErrorFromResponse } from 'helpers/ContentHelper';
import { SEND_EMAIL } from './EmailSubmissionFormActions';

const INITIAL_STATE = {
  emailAccessToken: null,
  emailSent: false,
};

export default function(state = INITIAL_STATE, action) {
  const errors = determineErrorFromResponse(action);
  switch (action.type) {
    case SEND_EMAIL:
      if (errors) return state;
      return {
        ...state,
        emailSent: true,
      };
    default:
      return state;
  }
}
